import React from 'react'
import { ListItem, MenuOverlay } from '@fs/zion-ui'
import { css } from '@linaria/core'
import { trackLink } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import debugLib from '@fs/zion-debug'
import { baseUrl } from '@fs/zion-config'
import HeaderNavButton from './HeaderNavButton'
import { useNavigationContext } from '../shared/NavigationProvider'

const debug = debugLib('header2019:nav')

const navCss = css`
  /* right-margin is to get the specified 60px buffer, including calculating padding on each side */
  margin-top: 10px;
  margin-bottom: 0;
  margin-inline-start: 10px;
  margin-inline-end: 0;
  display: flex;
`

export default function NavLinksDesktop({ external }) {
  const [t] = useTranslation()

  const { headerNavigation } = useNavigationContext()
  debug('navigation Links:', headerNavigation)

  if (!headerNavigation) {
    return null
  }

  return (
    <nav aria-label={t('nav.main', 'Main')} className={navCss}>
      {/* Without an aria-label, this is just listed as "navigation" to screenreaders (now lists as "Main navigation") */}
      {headerNavigation.map((link) => (
        <span key={link.id}>
          <MenuOverlay menuButton={<HeaderNavButton data-test-id={`hdr_${link.id}`}>{link.text}</HeaderNavButton>}>
            {link.sub.map((sub) => (
              <ListItem
                key={sub.url}
                to={`${external && sub.url.startsWith('/') ? baseUrl : ''}${sub.url}`}
                onClick={() =>
                  trackLink(null, sub.url, 'click_action', `hdr19_${link.id}:${sub.id}${sub.abTestString || ''}`)
                }
                primaryText={sub.text}
                external
                data-test-id={`hdr_${link.id}_${sub.id}`}
              />
            ))}
          </MenuOverlay>
        </span>
      ))}
    </nav>
  )
}
